import type { Voice, VoiceType } from './types';

const getAllSupportedLocales = () => [
  { locale: 'en-US' },
  { locale: 'en-GB' },
  { locale: 'de-DE' },
  { locale: 'fr-FR' },
  { locale: 'es-ES' },
  { locale: 'es-MX' },
  { locale: 'it-IT' },
  { locale: 'pt-BR' },
  { locale: 'pt-PT' },
  { locale: 'nl-NL' },
  { locale: 'pl-PL' },
  { locale: 'ro-RO' },
  { locale: 'uk-UA' },
  { locale: 'ru-RU' },
  { locale: 'ar-SA' },
  { locale: 'tr-TR' },
  { locale: 'hi-IN' },
  { locale: 'bn-IN' },
  { locale: 'mr-IN' },
  { locale: 'ta-IN' },
  { locale: 'te-IN' },
];

export const newVoices: Voice[] = [
  {
    slug: 'autonoe',
    provider: 'alpha',
    name: 'Clara',
    locale: 'en-US',
    gender: 'female',
    avatar_image:
      'https://vms.cdn.speechify.com/avatars/fcd41964-9e61-48db-b20e-8b0f277e815c.webp',
    id: 'autonoe',
    type: 'shared' as VoiceType,
    display_name: 'Clara',
    models: [
      {
        languages: getAllSupportedLocales(),
        name: 'simba-multilingual',
      },
    ],
  },
  {
    slug: 'despina',
    provider: 'alpha',
    name: 'Sophie',
    locale: 'en-US',
    gender: 'female',
    avatar_image:
      'https://vms.cdn.speechify.com/avatars/53bf14da-cf11-4c82-9784-a3375a4e6cc9.webp',
    id: 'despina',
    type: 'shared' as VoiceType,
    display_name: 'Sophie',
    models: [
      {
        languages: getAllSupportedLocales(),
        name: 'simba-multilingual',
      },
    ],
  },
  {
    slug: 'erinome',
    provider: 'alpha',
    name: 'Laura',
    locale: 'en-US',
    gender: 'female',
    avatar_image:
      'https://vms.cdn.speechify.com/avatars/4b6dbf82-bded-4007-bdc1-6bf2cdb5bd54.webp',
    id: 'erinome',
    type: 'shared' as VoiceType,
    display_name: 'Laura',
    models: [
      {
        languages: getAllSupportedLocales(),
        name: 'simba-multilingual',
      },
    ],
  },
  {
    slug: 'laomedeia',
    provider: 'alpha',
    name: 'Katie',
    locale: 'en-US',
    gender: 'female',
    avatar_image:
      'https://vms.cdn.speechify.com/avatars/8a2f870f-e119-47e0-87b8-9bb076ffe145.webp',
    id: 'laomedeia',
    type: 'shared' as VoiceType,
    display_name: 'Katie',
    models: [
      {
        languages: getAllSupportedLocales(),
        name: 'simba-multilingual',
      },
    ],
  },
  {
    slug: 'achird',
    provider: 'alpha',
    name: 'Jason',
    locale: 'en-US',
    gender: 'male',
    avatar_image:
      'https://vms.cdn.speechify.com/avatars/470ea8f6-b432-4eb1-839a-926e4b8c685e.webp',
    id: 'achird',
    type: 'shared' as VoiceType,
    display_name: 'Jason',
    models: [
      {
        languages: getAllSupportedLocales(),
        name: 'simba-multilingual',
      },
    ],
  },
  {
    slug: 'gacrux',
    provider: 'alpha',
    name: 'Maggie',
    locale: 'en-US',
    gender: 'female',
    avatar_image:
      'https://vms.cdn.speechify.com/avatars/6554fe6d-c610-449c-8f14-f4359ad0d6ca.webp',
    id: 'gacrux',
    type: 'shared' as VoiceType,
    display_name: 'Maggie',
    models: [
      {
        languages: getAllSupportedLocales(),
        name: 'simba-multilingual',
      },
    ],
  },
  {
    slug: 'aoede',
    provider: 'alpha',
    name: 'Chloe',
    locale: 'en-US',
    gender: 'female',
    avatar_image:
      'https://vms.cdn.speechify.com/avatars/80ecd8cc-993c-40f2-80e4-05f32d7d9b7d.webp',
    id: 'aoede',
    type: 'shared' as VoiceType,
    display_name: 'Chloe',
    models: [
      {
        languages: getAllSupportedLocales(),
        name: 'simba-multilingual',
      },
    ],
  },
  {
    slug: 'algenib',
    provider: 'alpha',
    name: 'Theodore',
    locale: 'en-US',
    gender: 'male',
    avatar_image:
      'https://vms.cdn.speechify.com/avatars/f708f80b-5db9-4029-8c0a-8e9e14d49279.webp',
    id: 'algenib',
    type: 'shared' as VoiceType,
    display_name: 'Theodore',
    models: [
      {
        languages: getAllSupportedLocales(),
        name: 'simba-multilingual',
      },
    ],
  },
  {
    slug: 'charon',
    provider: 'alpha',
    name: 'Walter',
    locale: 'en-US',
    gender: 'male',
    avatar_image:
      'https://vms.cdn.speechify.com/avatars/2e55cd71-3964-41b6-ab6f-44b68dc9aa6a.webp',
    id: 'charon',
    type: 'shared' as VoiceType,
    display_name: 'Walter',
    models: [
      {
        languages: getAllSupportedLocales(),
        name: 'simba-multilingual',
      },
    ],
  },
];
